import type { ClicktripzArrival } from './types';
import { browser } from '$app/environment';
import { createCheckConsentForVendor } from '$lib/services/tracking/didomi/consent';
import { addScriptTag } from '../script';

const CLICKTRIPZ_VENDOR_ID = 'c:clicktripz';
const localesISO3to2: Record<string, string> = {
	ALB: 'AL',
	DZA: 'DZ',
	AND: 'AD',
	ARG: 'AR',
	ARM: 'AM',
	AUS: 'AU',
	AUT: 'AT',
	BLR: 'BY',
	BEL: 'BE',
	BIH: 'BA',
	BRA: 'BR',
	BGR: 'BG',
	CAN: 'CA',
	CHL: 'CL',
	CHN: 'CN',
	HKG: 'HK',
	MAC: 'MO',
	COL: 'CO',
	CRI: 'CR',
	CIV: 'CI',
	HRV: 'HR',
	CUB: 'CU',
	CYP: 'CY',
	CZE: 'CZ',
	DNK: 'DK',
	ECU: 'EC',
	EGY: 'EG',
	EST: 'EE',
	ETH: 'ET',
	FIN: 'FI',
	FRA: 'FR',
	GUF: 'GF',
	PYF: 'PF',
	GEO: 'GE',
	DEU: 'DE',
	GRC: 'GR',
	GLP: 'GP',
	GTM: 'GT',
	GIN: 'GN',
	GUY: 'GY',
	HUN: 'HU',
	ISL: 'IS',
	IND: 'IN',
	IDN: 'ID',
	IRN: 'IR',
	IRQ: 'IQ',
	IRL: 'IE',
	ITA: 'IT',
	JPN: 'JP',
	KOR: 'KR',
	LVA: 'LV',
	LBN: 'LB',
	LTU: 'LT',
	LUX: 'LU',
	MKD: 'MK',
	MDG: 'MG',
	MYS: 'MY',
	MTQ: 'MQ',
	MEX: 'MX',
	MDA: 'MD',
	MCO: 'MC',
	MAR: 'MA',
	NLD: 'NL',
	NOR: 'NO',
	POL: 'PL',
	PRT: 'PT',
	REU: 'RE',
	ROU: 'RO',
	RUS: 'RU',
	SEN: 'SN',
	SRB: 'RS',
	SGP: 'SG',
	SVK: 'SK',
	SVN: 'SI',
	ZAF: 'ZA',
	ESP: 'ES',
	SWE: 'SE',
	CHE: 'CH',
	TUN: 'TN',
	TUR: 'TR',
	UKR: 'UA',
	GBR: 'GB',
	USA: 'US',
};
const SCRIPT_ID = 'clicktripz-ad-script';
const clicktripzAttributes = { 'data-publisher': '55bd9fc9db1047429e0d1d63d928a397', 'fetchpriority': 'low' };

// Documentation: https://support.clicktripz.com/hc/en-us/categories/115001382147-Technical-Documentation
// From clicktripz support: 2 modal triggers per 24 hours per combination of IP address + user agent (normally)
export function setupClicktripzAd({ onLoad }: { onLoad: () => void }) {
	addScriptTag(SCRIPT_ID, 'https://static.clicktripz.com/tag.js', {
		attributes: clicktripzAttributes,
		onLoad,
	});
}

export const checkConsentForClicktripz = createCheckConsentForVendor(CLICKTRIPZ_VENDOR_ID);

export function setClicktripzInfos(arrival: ClicktripzArrival) {
	if (browser) {
		const { city, countryCode } = arrival;

		window._CTZ = {
			enabled: typeof window._CTZ?.enabled === 'boolean' ? window._CTZ.enabled : true,
			verticals: {
				hotel: {
					active: true,
					search: { city, countryCode: localesISO3to2[countryCode] },
				},
			},
		};
	}
}
